import { ViewModel,View, ObservableArray } from "binder"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { PaginationInfo, ServerSideDataLoader } from "uicomponents";
import { SearchCustomerViewModel } from "../searchCustomer/searchCustomer-viewModel";
import  { InterfacePersonsListView } from "./interfacePersonsList-view"
import { AddNewInterfacePersonViewModel } from "../addNewInterfacePerson/addNewInterfacePerson-viewModel";

export class InterfacePersonsListViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'لیست تحویل گیرنده';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.interfacePersons = ObservableArray.create<InterfacePerson>();
        this.loader = new ServerSideDataLoader(filteringInformation=>this.refreshPaged(filteringInformation),15);
        this.customerSelector = new SearchCustomerViewModel(this);
        this.customerSelector.onSelectionChanged = w =>{
            this.selectedCustomerId = w.id;
            this.selectedCustomerName = w.title;
            this.refresh();
            this.customerSelected = true;
        }
    }
    GetDefaultView(): View <ViewModel> {
        return new InterfacePersonsListView();
    }
    public getTypeId(): string {
        return "VM-68F57EC9-FC3F-4AAE-B1CF-4CDECF046696"
    }
    public set loader(v: ServerSideDataLoader) { this._loader = v; } public get loader(): ServerSideDataLoader { return this._loader;} private _loader: ServerSideDataLoader;
    public set interfacePersons(v: ObservableArray<InterfacePerson>) { this._interfacePersons = v; } public get interfacePersons(): ObservableArray<InterfacePerson> { return this._interfacePersons;} private _interfacePersons: ObservableArray<InterfacePerson>;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set customerSelector(v: SearchCustomerViewModel) { this._customerSelector = v; } public get customerSelector(): SearchCustomerViewModel { return this._customerSelector;} private _customerSelector: SearchCustomerViewModel;
    public set selectedCustomerName(v: string) { this._selectedCustomerName = v; } public get selectedCustomerName(): string { return this._selectedCustomerName;} private _selectedCustomerName: string;
    public set selectedCustomerId(v: string) { this._selectedCustomerId = v; } public get selectedCustomerId(): string { return this._selectedCustomerId;} private _selectedCustomerId: string;
    public set customerSelected(v: boolean) { this._customerSelected = v; } public get customerSelected(): boolean { return this._customerSelected;} private _customerSelected: boolean;
    
    refresh(){
        this.loader.refresh();
    }
    async refreshPaged(filteringInformation:any): Promise<PaginationInfo>{
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/CrmServices/GetAllInterfacePersonsByCustomer',{
                FilteringInformation:filteringInformation,
                CustomerId:this.selectedCustomerId
            });
            let rowNumber = 1;
            this.interfacePersons.update(...result.InterfacePersons.map(q=>{
                let r = new InterfacePerson(this);
                r.id = q.Id;
                r.rowNumber = rowNumber++;
                r.fullName = q.FullName;
                r.nationalCode = q.NationalCode;
                r.phone = q.Phone;
                r.comment = q.Comment;
                return r;
            }));
            return new PaginationInfo(result.PaginationInfo.CurrentPage,result.PaginationInfo.PageCount);
        } catch (ex) {
            console.log(ex);
            return new PaginationInfo(0,0);
        } finally {
            this.isLoading = false;
        }
    }
 
    async disable(id:string){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/CrmServices/DisableInterfacePerson',{
                Id:id
            });
            if(result.IsSuccessful==false){
                throw "new Error";
            }
            await this.messageBoxConfirmSuccess('تحویل گیرنده حذف شد','عملیات موفق');
        } catch (ex) {
            console.log(ex);
            await this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
            this.loader.refresh();
        }
    }
    
    async showAddNewInterfacePersonForm() {
        let newInterface = new AddNewInterfacePersonViewModel(this, this.selectedCustomerId);
        let result = await this.requestShowingPopup(newInterface);
        if (result) 
            this.refresh();
    }

}

export class InterfacePerson extends ViewModel {
    
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:InterfacePersonsListViewModel) {
        super(parent);
        this._typedParent = parent;
    }
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set rowNumber(v: number) { this._rowNumber = v; } public get rowNumber(): number { return this._rowNumber;} private _rowNumber: number;
    public set fullName(v: string) { this._fullName = v; } public get fullName(): string { return this._fullName;} private _fullName: string;
    public set nationalCode(v: string) { this._nationalCode = v; } public get nationalCode(): string { return this._nationalCode;} private _nationalCode: string;
    public set phone(v: string) { this._phone = v; } public get phone(): string { return this._phone;} private _phone: string;
    public set comment(v: string) { this._comment = v; } public get comment(): string { return this._comment;} private _comment: string;
    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    
    private _typedParent:InterfacePersonsListViewModel;

    async disable(){
        this._typedParent.disable(this.id);
    }  
    
}